<div class="story-details">
  <div class="details">
    <fa-icon
      [icon]="['fas', 'times-circle']"
      class="close-details"
      (click)="closeDetails()"
    ></fa-icon>
    @if (post && post.thumbnail_big) {
      <div class="thumbnail">
        <img [src]="post.thumbnail_big" appFallbackImage appLazyLoad />
      </div>
    }
    <div class="content">
      @if (post && post.source) {
        <div class="source">
          <img [src]="post.source.icon_url" appFallbackImage appLazyLoad />
          {{ post.source.title }}
        </div>
      }
      @if (post) {
        <div class="title">
          <h4>
            <a
              [href]="postUrlInternal"
              target="_blank"
              [innerHTML]="post.title"
            ></a>
          </h4>
        </div>
      }
      <div class="post-info">
        <div
          class="sentiment {{
            post?.post_sentiment_algorithm_list[0].sentiment_id ==
            NomSentiment.NEUTRAL
              ? 'neutral'
              : post?.post_sentiment_algorithm_list[0].sentiment_id ==
                  NomSentiment.POSITIVE
                ? 'positive'
                : 'negative'
          }}"
        >
          {{ post?.post_sentiment_algorithm_list[0].title }}
        </div>
        <div class="post-dates">
          @if (post && post.publish_time) {
            <div class="post-date">
              <span class="post-date__label">
                {{ "story-card.label.published" | translate }}
              </span>
              {{ post.publish_time.absolute | date: "dd.MM.yyyy HH:mm" }} ({{
                post.publish_time.relative
              }})
            </div>
          }
          @if (post && post.created_time) {
            <div class="post-date">
              <span class="post-date__label">
                {{ "story-card.label.created" | translate }}
              </span>
              {{ post.created_time.absolute | date: "dd.MM.yyyy HH:mm" }} ({{
                post.created_time.relative
              }})
            </div>
          }
        </div>
      </div>
      @if (post?.content) {
        <div class="content">
          {{
            isContentExpanded ? post.content : (post.content | slice: 0 : 75)
          }}
          @if (post.content.length > 75) {
            <span
              class="toggle-content"
              (click)="isContentExpanded = !isContentExpanded"
            >
              {{
                (isContentExpanded
                  ? "story-card.toggle.show-less"
                  : "story-card.toggle.show-more"
                ) | translate
              }}
              <fa-icon
                [icon]="['fas', isContentExpanded ? 'caret-up' : 'caret-down']"
              ></fa-icon>
            </span>
          }
        </div>
      }
    </div>
  </div>

  <ul class="nav nav-tabs">
    @for (tab of tabs; track tab; let i = $index) {
      <li class="nav-item">
        @if (tab.visible) {
          <a
            class="nav-link"
            [ngClass]="{ active: tab.active }"
            (click)="selectTab(tab, i)"
            >{{ tab.label }}</a
          >
        }
      </li>
    }
  </ul>

  <ng-container #tabContent></ng-container>
</div>
